import gql from 'graphql-tag';

import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import { MaintenanceRequestFields } from '../../../fragments/web/maintenance/MaintenanceRequestFields';
import { ListMaintenanceRequests } from '../../../athena/types/ListMaintenanceRequests';

export const LIST_MAINTENANCE_REQUESTS = gql`
  query ListMaintenanceRequests(
    $orgId: String!
    $startPeriod: OdProtosCommon_DateInput!
    $endPeriod: OdProtosCommon_DateInput!
    $states: [OdProtosWebData_MaintenanceRequest_State!]!
    $offset: Float!
    $pageSize: Float!
  ) {
    webMaintenance {
      listMaintenanceRequests(
        input: {
          requestType: {
            vendorRequest: {
              vendorOrganizationId: $orgId
              startPeriodOn: $startPeriod
              endPeriodOn: $endPeriod
              states: $states
            }
          }
          pagination: { offset: $offset, pageSize: $pageSize }
        }
      ) {
        maintenanceRequests {
          ...MaintenanceRequestFields
        }
        totalCount
      }
    }
  }

  ${MaintenanceRequestFields}
`;

const useListMaintenanceRequests = (options?: QueryHookOptions<ListMaintenanceRequests>) =>
  useQuery<ListMaintenanceRequests>(LIST_MAINTENANCE_REQUESTS, options);

export default useListMaintenanceRequests;
